<mat-card appearance="outlined" (window:resize)="onResize($event)">
  <mat-card-header>
    <mat-card-title>
      <mat-icon class="icon-20">people</mat-icon> User Administration ({{users.length}})
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="flex flex-col">
      <div class="flex flex-row" *ngIf="!processing">
        <mat-form-field>
          <input matInput (keyup)="filterTable($event)" placeholder="Filter" />
        </mat-form-field>
        <span>
          <a (click)="openAddUserDialog()" mat-icon-button aria-label="Add new users" title="Add new users">
            <mat-icon>person_add</mat-icon>
          </a>
        </span>
      </div>
      <section *ngIf="processing">
        <h2>Loading...</h2>
        <mat-progress-bar mode="indeterminate" color="warn" aria-label="Loading content">
        </mat-progress-bar>
      </section>
      <table mat-table [dataSource]="dataSource" matSort #TableUsersSort="matSort" aria-describedby="Users"
        class="mat-elevation-z8 demo-table w-full">
        <ng-container matColumnDef="userName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Username</th>
          <td mat-cell *matCellDef="let user">{{user.userName}}</td>
        </ng-container>
        <ng-container matColumnDef="fullName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Name</th>
          <td mat-cell *matCellDef="let user">{{user.fullName}}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Email</th>
          <td mat-cell *matCellDef="let user">{{user.email}}</td>
        </ng-container>

        <ng-container matColumnDef="roles">
          <th mat-header-cell *matHeaderCellDef>Roles</th>
          <td mat-cell *matCellDef="let user">
            <span *ngIf="user.roles != null && user.roles.length > 0">
              <span *ngFor="let role of user.roles">
                {{role}}<br />
              </span>
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let user">
            <div class="flex flex-row">
              <mat-icon class="icon-20" title="Edit User: {{user.fullName}}"
                (click)="openEditUserDialog(user)">edit</mat-icon>
              <span>&nbsp;&nbsp;</span>
              <mat-icon class="icon-20" title="Remove User: {{user.fullName}}" (click)="openRemoveUserDialog(user)"
                class="text-red-500">delete</mat-icon>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <mat-paginator [pageSizeOptions]="[10, 20, 50]" #TableUsersPaginator="matPaginator" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>